import { defineStore } from 'pinia';
import { User } from '@/types/types';

export const useUserStore = defineStore({
  id: 'user',

  state: () => ({
    idToken: sessionStorage.getItem('idToken') as string | null,
    user: JSON.parse(sessionStorage.getItem('user') || 'null') as User | null
  }),

  actions: {
    setIdToken(idToken: string) {
      this.idToken = idToken;
      sessionStorage.setItem('idToken', idToken);
    },
    clearIdToken() {
      this.idToken = null;
      sessionStorage.removeItem('idToken');
    },
    setUser(user: User | null) {
      this.user = user;
      if (user) {
        sessionStorage.setItem('user', JSON.stringify(user));
      } else {
        sessionStorage.removeItem('user');
      }
    }
  }
});
